import { ContentStateInterface, ContentStateProperty, OnChangeValue } from '../../../../@types/types'
import _ from 'lodash'

export const insertionDataWithChangedProperty = (
  insertionData: ContentStateInterface,
  property: ContentStateProperty,
  value: OnChangeValue
) => {
  const newInsertionData = _.cloneDeep(insertionData)
  _.set(newInsertionData, property, value)

  return newInsertionData
}
